/**
 * Quick Login One Tap JavaScript
 * Auto-show login prompt after 5 seconds for non-logged users
 * Integrates with Growave social login
 */

// Removed UA-based in-app browser detection to avoid userAgent logic


// Track post-redirect auth success (mainly social login) so we can compute conversion by variant.
(function () {
  const AUTH_ATTEMPT_STORAGE_KEY = "quick_login_auth_attempt";
  const AUTH_ATTEMPT_TTL_MS = 10 * 60 * 1000; // 10 minutes
  const EPOCH_SECONDS_MIN_2000 = 946684800; // 2000-01-01 in seconds
  const EPOCH_MS_MIN_2000 = 946684800000; // 2000-01-01 in ms
  const ALLOWED_FUTURE_SKEW_MS = 5 * 60 * 1000; // 5 minutes

  function getDeviceType() {
    return window.innerWidth <= 768 ? "mobile" : "desktop";
  }

  function toEpochMs(value) {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) return null;
    if (numericValue >= EPOCH_MS_MIN_2000) return numericValue;
    if (numericValue >= EPOCH_SECONDS_MIN_2000) return numericValue * 1000;
    return null;
  }

  function sanitizeEpochMs(epochMs) {
    if (!Number.isFinite(epochMs)) return null;
    const now = Date.now();
    if (epochMs > now + ALLOWED_FUTURE_SKEW_MS) return null;
    // Handle small clock skew (server time slightly ahead of client).
    return epochMs > now ? now : epochMs;
  }

  function safeParseJson(value) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  }

  function getShopifyCustomerId() {
    try {
      return window.ShopifyAnalytics?.meta?.page?.customerId || null;
    } catch (e) {
      return null;
    }
  }

  function getQuickLoginCustomerMeta() {
    try {
      if (
        window.__quickLoginCustomer &&
        typeof window.__quickLoginCustomer === "object"
      ) {
        return window.__quickLoginCustomer;
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  function getCustomerCreatedAtMs() {
    const meta = getQuickLoginCustomerMeta();
    if (!meta) return null;
    const rawCreatedAtMs = meta.created_at_ms;
    if (rawCreatedAtMs === null || typeof rawCreatedAtMs === "undefined")
      return null;
    if (rawCreatedAtMs === "" || rawCreatedAtMs === "null") return null;

    const createdAtMs = sanitizeEpochMs(toEpochMs(rawCreatedAtMs));
    return Number.isFinite(createdAtMs) ? createdAtMs : null;
  }

  function getCustomerOrdersCount() {
    const meta = getQuickLoginCustomerMeta();
    if (!meta) return null;
    const rawOrdersCount = meta.orders_count;
    if (rawOrdersCount === null || typeof rawOrdersCount === "undefined")
      return null;
    const ordersCount = Number(rawOrdersCount);
    return Number.isFinite(ordersCount) && ordersCount >= 0
      ? ordersCount
      : null;
  }

  function customerHasTagForAttemptTag(customerMeta, attemptTag) {
    if (!customerMeta || !attemptTag) return false;
    const tag = String(attemptTag).trim();
    if (!tag) return false;

    if (tag === "testcouponv2")
      return customerMeta.has_tag_testcouponv2 === true;
    if (tag === "loginv1") return customerMeta.has_tag_loginv1 === true;
    return false;
  }

  function inferIsNewCustomerFromTags({ attemptTag, customerMeta }) {
    if (!customerMeta) return null;

    if (!customerHasTagForAttemptTag(customerMeta, attemptTag)) return null;

    const ordersCount = Number(customerMeta.orders_count);
    if (!Number.isFinite(ordersCount) || ordersCount < 0) return null;

    // Heuristic: tags are expected to be applied on account creation; combine with "no orders" for safety.
    return ordersCount === 0 ? 1 : 0;
  }

  function inferIsNewCustomer({ customerCreatedAtMs, attemptStartedAtMs }) {
    const normalizedCreatedAtMs = sanitizeEpochMs(
      toEpochMs(customerCreatedAtMs),
    );
    const normalizedAttemptStartedAtMs = sanitizeEpochMs(
      toEpochMs(attemptStartedAtMs),
    );
    if (
      !Number.isFinite(normalizedCreatedAtMs) ||
      !Number.isFinite(normalizedAttemptStartedAtMs)
    )
      return null;

    const accountAgeMs = Date.now() - normalizedCreatedAtMs;
    if (!Number.isFinite(accountAgeMs) || accountAgeMs < 0) return null;

    const createdAfterAttempt =
      normalizedCreatedAtMs >= normalizedAttemptStartedAtMs - 2 * 60 * 1000;
    if (!createdAfterAttempt) return 0;
    return accountAgeMs <= AUTH_ATTEMPT_TTL_MS ? 1 : 0;
  }

  function isCustomerLoggedIn() {
    const meta = getQuickLoginCustomerMeta();
    if (meta && meta.is_logged_in === true) return true;
    if (getShopifyCustomerId()) return true;
    if (
      document.querySelector(
        'a[href^=\"/account/logout\"], a[href*=\"/account/logout\"]',
      )
    )
      return true;
    return false;
  }

  function trackQuickLoginEvent(eventName, params = {}) {
    const baseParams = {
      device: getDeviceType(),
      timestamp: Date.now(),
    };

    const eventParams = { ...baseParams, ...params };

    // OpenPanel
    if (window.OpenPanel && typeof window.OpenPanel.track === "function") OpenPanel.track(eventName, eventParams);

    // GA4
    if (typeof window.gtag === "function") {
      try {
        window.gtag("event", eventName, eventParams);
      } catch (e) {}
    } else if (typeof gtag !== "undefined") {
      try {
        gtag("event", eventName, eventParams);
      } catch (e) {}
    }

    // DataLayer for GTM
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...eventParams,
    });

    // Microsoft Clarity
    if (typeof window.clarity === "function") {
      try {
        window.clarity(
          "set",
          "quick_login_device",
          String(eventParams.device || ""),
        );

        if (eventParams.quick_login_source) {
          window.clarity(
            "set",
            "quick_login_source",
            String(eventParams.quick_login_source),
          );
        }
        if (eventParams.tags) {
          window.clarity("set", "quick_login_tags", String(eventParams.tags));
        }

        if (eventParams.provider) {
          window.clarity(
            "set",
            "quick_login_provider",
            String(eventParams.provider),
          );
        }
        if (eventParams.auth_method) {
          window.clarity(
            "set",
            "quick_login_auth_method",
            String(eventParams.auth_method),
          );
        }
        if (typeof eventParams.is_new_customer !== "undefined") {
          window.clarity(
            "set",
            "quick_login_is_new_customer",
            String(eventParams.is_new_customer),
          );
        }
        if (eventParams.is_new_customer_infer_source) {
          window.clarity(
            "set",
            "quick_login_is_new_customer_infer_source",
            String(eventParams.is_new_customer_infer_source),
          );
        }
        if (eventParams.customer_created_at_source) {
          window.clarity(
            "set",
            "quick_login_customer_created_at_source",
            String(eventParams.customer_created_at_source),
          );
        }

        window.clarity("event", String(eventName));
      } catch (e) {}
    }
  }

  function readAuthAttempt() {
    try {
      const raw = localStorage.getItem(AUTH_ATTEMPT_STORAGE_KEY);
      return raw ? safeParseJson(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function clearAuthAttempt() {
    try {
      localStorage.removeItem(AUTH_ATTEMPT_STORAGE_KEY);
    } catch (e) {}
  }

  function extractQuickLoginCustomerMetaFromHtml(html) {
    try {
      if (!html || typeof html !== "string") return null;

      const blockMatch = html.match(
        /window\.__quickLoginCustomer\s*=\s*\{[\s\S]*?\};/,
      );
      if (!blockMatch) return null;
      const block = blockMatch[0];

      const createdAtMatch = block.match(/created_at_ms:\s*(null|\d+)/i);
      const ordersCountMatch = block.match(/orders_count:\s*(null|\d+)/i);
      const hasTagV2Match = block.match(
        /has_tag_testcouponv2:\s*(true|false)/i,
      );
      const hasTagV1Match = block.match(/has_tag_loginv1:\s*(true|false)/i);

      const createdAtMs =
        createdAtMatch && createdAtMatch[1] !== "null"
          ? sanitizeEpochMs(toEpochMs(createdAtMatch[1]))
          : null;
      const ordersCount =
        ordersCountMatch && ordersCountMatch[1] !== "null"
          ? Number(ordersCountMatch[1])
          : null;

      const meta = {};

      if (Number.isFinite(createdAtMs)) meta.created_at_ms = createdAtMs;
      if (Number.isFinite(ordersCount) && ordersCount >= 0)
        meta.orders_count = ordersCount;
      if (hasTagV2Match)
        meta.has_tag_testcouponv2 = hasTagV2Match[1] === "true";
      if (hasTagV1Match) meta.has_tag_loginv1 = hasTagV1Match[1] === "true";

      return Object.keys(meta).length > 0 ? meta : null;
    } catch (e) {
      return null;
    }
  }

  function extractCustomerCreatedAtMsFromHtml(html) {
    try {
      if (!html || typeof html !== "string") return null;
      const match = html.match(
        /__quickLoginCustomer\s*=\s*\{[\s\S]*?created_at_ms:\s*(null|\d+)/i,
      );
      if (!match) return null;
      if (match[1] === "null") return null;
      const createdAtMs = sanitizeEpochMs(toEpochMs(match[1]));
      return Number.isFinite(createdAtMs) ? createdAtMs : null;
    } catch (e) {
      return null;
    }
  }

  async function fetchQuickLoginCustomerMetaFromAccountPage() {
    try {
      const response = await fetch("/account", {
        credentials: "same-origin",
        cache: "no-store",
      });
      const finalUrl = response.url || "";
      if (finalUrl.includes("/account/login")) return null;
      if (!response.ok) return null;
      const html = await response.text();
      return extractQuickLoginCustomerMetaFromHtml(html);
    } catch (e) {
      return null;
    }
  }

  async function fetchCustomerCreatedAtMsFromAccountPage() {
    try {
      const response = await fetch("/account", {
        credentials: "same-origin",
        cache: "no-store",
      });
      const finalUrl = response.url || "";
      if (finalUrl.includes("/account/login")) return null;
      if (!response.ok) return null;
      const html = await response.text();
      return extractCustomerCreatedAtMsFromHtml(html);
    } catch (e) {
      return null;
    }
  }

  let isProcessingAttempt = false;

  async function processAuthAttempt() {
    const attempt = readAuthAttempt();
    if (!attempt || typeof attempt !== "object") return;

    const startedAt = Number(attempt.started_at || 0);
    if (!startedAt) {
      clearAuthAttempt();
      return;
    }

    const ageMs = Date.now() - startedAt;
    if (ageMs > AUTH_ATTEMPT_TTL_MS) {
      clearAuthAttempt();
      return;
    }

    if (!isCustomerLoggedIn()) return;
    if (isProcessingAttempt) return;
    isProcessingAttempt = true;

    try {
      let customerMeta = getQuickLoginCustomerMeta() || {};
      let customerOrdersCount = getCustomerOrdersCount();

      let customerCreatedAtMs = getCustomerCreatedAtMs();
      let customerCreatedAtSource = Number.isFinite(customerCreatedAtMs)
        ? "page_liquid"
        : null;

      if (
        !Number.isFinite(customerCreatedAtMs) ||
        typeof customerOrdersCount !== "number"
      ) {
        const accountMeta = await fetchQuickLoginCustomerMetaFromAccountPage();
        if (accountMeta && typeof accountMeta === "object") {
          customerMeta = { ...customerMeta, ...accountMeta };
          if (
            !Number.isFinite(customerCreatedAtMs) &&
            Number.isFinite(accountMeta.created_at_ms)
          ) {
            customerCreatedAtMs = accountMeta.created_at_ms;
            customerCreatedAtSource = "account_fetch";
          }
          if (
            typeof customerOrdersCount !== "number" &&
            typeof accountMeta.orders_count === "number"
          ) {
            customerOrdersCount = accountMeta.orders_count;
          }
        }
      }

      if (!Number.isFinite(customerCreatedAtMs)) {
        customerCreatedAtMs = await fetchCustomerCreatedAtMsFromAccountPage();
        if (Number.isFinite(customerCreatedAtMs))
          customerCreatedAtSource = "account_fetch";
      }

      let inferredIsNewCustomer = inferIsNewCustomer({
        customerCreatedAtMs: customerCreatedAtMs ?? NaN,
        attemptStartedAtMs: startedAt,
      });
      let inferredIsNewCustomerSource =
        typeof inferredIsNewCustomer === "number" ? "created_at" : null;

      if (typeof inferredIsNewCustomer !== "number") {
        inferredIsNewCustomer = inferIsNewCustomerFromTags({
          attemptTag: attempt.tags,
          customerMeta,
        });
        if (typeof inferredIsNewCustomer === "number") {
          inferredIsNewCustomerSource = "tag_orders_count";
        }
      }

      let customerCreatedAtMsAvailable = Number.isFinite(customerCreatedAtMs);
      let customerCreatedAtMsEstimated = false;

      if (!customerCreatedAtMsAvailable && inferredIsNewCustomer === 1) {
        customerCreatedAtMs = startedAt;
        customerCreatedAtSource = "approx_attempt_started_at";
        customerCreatedAtMsAvailable = Number.isFinite(customerCreatedAtMs);
        customerCreatedAtMsEstimated = true;
      }

      const accountAgeMs = Number.isFinite(customerCreatedAtMs)
        ? Date.now() - customerCreatedAtMs
        : null;

      const payload = {
        attempt_id: attempt?.id || "",
        auth_method: attempt?.auth_method || "social",
        provider: attempt?.provider || "",
        tags: attempt?.tags || "",
        source: attempt?.quick_login_source || "quick_login_popup",
        time_to_success_ms: ageMs,
        origin_path: attempt?.origin_path || "",
        landing_path: window.location.pathname,
      };

      if (customerCreatedAtSource) {
        payload.customer_created_at_source = customerCreatedAtSource;
      }

      if (typeof customerOrdersCount === "number") {
        payload.customer_orders_count = customerOrdersCount;
      }

      if (Number.isFinite(accountAgeMs) && accountAgeMs >= 0) {
        payload.account_age_ms = accountAgeMs;
      }
      if (Number.isFinite(customerCreatedAtMs)) {
        payload.customer_created_at_ms = customerCreatedAtMs;
      }
      payload.customer_created_at_ms_available = customerCreatedAtMsAvailable
        ? 1
        : 0;
      if (customerCreatedAtMsEstimated) {
        payload.customer_created_at_ms_estimated = 1;
      }
      if (typeof inferredIsNewCustomer === "number") {
        payload.is_new_customer = inferredIsNewCustomer;
        payload.is_new_customer_inferred = 1;
        if (inferredIsNewCustomerSource) {
          payload.is_new_customer_infer_source = inferredIsNewCustomerSource;
        }
      }

      trackQuickLoginEvent("quick_login_auth_success", payload);

      clearAuthAttempt();
    } finally {
      isProcessingAttempt = false;
    }
  }

  // Run once now and once later (ShopifyAnalytics may load late).
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", processAuthAttempt);
  } else {
    processAuthAttempt();
  }
  setTimeout(processAuthAttempt, 2000);
})();
